import { useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import moment from 'moment';
import { File, UploadCloud } from 'lucide-react';
import InnerLoader from '../ui/loader/inner-loader';
import { Link } from 'react-router';

const InvoiceModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, invoiceData, vanVendors = [] ,carVendors = [] }) => {
  const apiCall = useApiCall();
  const [imageError , setImageError] = useState(false);

  useEffect(() => {
    console.log("invoiceData", invoiceData);

  
    if (invoiceData?.invoice_id) {
      formik.setFieldValue("vendor_id", invoiceData?.vendor_id || "")
      formik.setFieldValue("invoice_month", moment(invoiceData?.invoice_month , "MMM-YYYY").format("YYYY-MM") || "")
      formik.setFieldValue("invoice_amount", invoiceData?.invoice_amount?.replaceAll(",", "") || "")
      formik.setFieldValue("invoice_file_path", invoiceData?.invoice_file_path || "")
      formik.setFieldValue("invoice_type", invoiceData?.invoice_type || "")
    }
  }, [])

  const validationSchema = yup.object({
    vendor_id : yup
      .string('This Field is Required')
      .required('This Field is Required'),
    invoice_month: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    invoice_amount: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    invoice_type: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    invoice_file_path:  yup
      .string('Invoice is Required')
      .required('Invoice is Required')

  });


  const formik = useFormik({
    initialValues: {
    vendor_id:'',
    invoice_month: '',
    invoice_amount: '',
    invoice_file_path: '',
    invoice_type: '',
    invoiceImageLoader: false,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("values", values)

      let extraData = {};

      if (invoiceData?.invoice_id) {
        extraData = {
          "id": invoiceData?.invoice_id
        }
      }

      let data = {
        ...extraData,
        "vendor_id": values?.vendor_id,
        "invoice_month": values?.invoice_month,
        "invoice_amount": values?.invoice_amount,
        "invoice_file_path":values.invoice_file_path,
        "invoice_type": values.invoice_type
      }

      try {
        let apiRes = await apiCall({ method: "post", url: (invoiceData?.invoice_id) ? `update-invoice` : "add-invoice", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });

  const handleFileUpload = async (file, type) => {
    let apiData = new FormData();
    apiData.append('file', file);
    if(type == "invoice_file_path"){
      setImageError(false);
      formik.setFieldValue("invoice_file_path", "");
      formik.setFieldValue("invoiceImageLoader", true);
    
    try {
      let apiRes = await apiCall({ method: "post", url: "upload", data: apiData });
    
      if(type == "invoice_file_path"){
        formik.setFieldValue("invoice_file_path", apiRes?.path?.filepath);
        formik.setFieldValue("invoiceImageLoader", false);
      }
      console.log("apiRes", apiRes?.path?.filepath, type);
    } catch (error) {
      console.log("Error", error)
    }
  }
}

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{(invoiceData?.invoice_id) ? "Update" : "Add"} Invoice</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                  {/* Invoice Type */}
                  <div className={Style["dcmb__cardBody_formArea_feild"]}>
                   <label htmlFor="">Type</label>
                   <select name='invoice_type' value={formik.values.invoice_type} onChange={formik.handleChange}>
                     <option value="" disabled selected>-- Select Type --</option>
                       <option value="Car">Car</option>
                       <option value="Van">Van</option>
                   
                   </select>
                   {/* { } */}
                   {
                     (formik.touched.vendor_id && Boolean(formik.errors.vendor_id)) ?
                       <span style={{ color: "red" }} className='ps-1'>{formik.touched.vendor_id && formik.errors.vendor_id}</span>
                       :
                       null
                   }
                 </div>
                 

                {/* Vendors */}

                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Vendor</label>
                  <select name='vendor_id' value={formik.values.vendor_id} onChange={formik.handleChange}>
                    <option value="" disabled selected>-- Select Vendor --</option>

                    {
                      (formik.values.invoice_type === "Car") ? 
                    
                    carVendors?.map((eachVendor, i) => (
                      <option value={eachVendor?.id} key={i}>{eachVendor?.name}</option>
                    ))

                    :
                    (formik.values.invoice_type === "Van") ? 


                     vanVendors?.map((eachVendor, i) => (
                      <option value={eachVendor?.id} key={i}>{eachVendor?.name}</option>
                    ))

                    :
                     null


                  }
                  </select>
                  {/* { } */}
                  {
                    (formik.touched.vendor_id && Boolean(formik.errors.vendor_id)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.vendor_id && formik.errors.vendor_id}</span>
                      :
                      null
                  }
                </div>

                {/* Invoice Month */}

                 <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Invoice Month</label>
                    <input
                      type="month"
                      name='invoice_month'
                      min={1}
                      value={formik.values.invoice_month}
                      onChange={formik.handleChange}
                      placeholder='Invoice month'
                    />
                    {
                      (formik.touched.invoice_month && Boolean(formik.errors.invoice_month)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.invoice_month && formik.errors.invoice_month}</span>
                        :
                        null
                    }
                  </div>
                </div>

                {/* Invoice Amount */}

                 <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Amount</label>
                    <input
                      type="number"
                      name='invoice_amount'
                      min={1}
                      value={formik.values.invoice_amount}
                      onChange={formik.handleChange}
                      placeholder='Amount'
                    />
                    {
                      (formik.touched.invoice_amount && Boolean(formik.errors.invoice_amount)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.invoice_amount && formik.errors.invoice_amount}</span>
                        :
                        null
                    }
                  </div>
                </div>

                {/* Invoice Image */}

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Invoice Image</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "invoice_file_path") }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.invoiceImageLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0], "invoice_file_path") }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.invoice_file_path ?
                      <div className="">
                        <Link to={formik.values?.invoice_file_path} target='_blank' className='inline-block'>
                          {imageError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.invoice_file_path} alt={formik?.values?.invoice_type} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setImageError(true);
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.invoice_file_path && Boolean(formik.errors.invoice_file_path)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.invoice_file_path && formik.errors.invoice_file_path}</span>
                        :
                        null
                    }
                  </div>
                </div>

               
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default InvoiceModal